'use client';

import React, { useCallback } from 'react';
import { Checkbox, MenuItem, TextField } from '@mui/material';
import { ProductType } from '@peerless/data-access/strapi';
import { usePathname, useRouter, useSearchParams } from '@/navigation';

interface Props {
  productTypes: ProductType[];
  selected: string[];
}

export const ProductTypeSelectFilter: React.FC<Props> = ({ productTypes, selected }) => {
  const router = useRouter();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  const onChange = useCallback(
    (productTypes: string) => {
      const params = new URLSearchParams(searchParams.toString());
      params.set('productTypes', productTypes);
      router.push(`${pathname}?${params.toString()}`);
    },
    [searchParams]
  );

  return (
    <TextField
      label="Product Types"
      value={selected}
      onChange={x => {
        if (!x.target.value) return;

        onChange(x.target.value as string);
      }}
      select
      SelectProps={{ multiple: true }}
      InputLabelProps={{ shrink: true }}
      fullWidth
    >
      {productTypes.map(x => (
        <MenuItem key={x.documentId} value={x.documentId}>
          <Checkbox checked={selected.includes(x.documentId.toString())} />
          {x.name}
        </MenuItem>
      ))}
    </TextField>
  );
};
